import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div`
    gap: 32px;
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const LocationTab = styled.div<{isActive: boolean }>`
    width: 660px;
    height: 180px;
    padding: 17px 28px 18px 22px;
    align-items: center;
    border-radius: ${BorderRadius.OuterBlockRadius};
    border-style: solid;
    border-width: 2px;
    background-color: rgba(255, 255, 255, .05);
    gap: 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 580px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 292px;
        height: 321px;
        flex-direction: column;
        padding: 17px;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        height: 269px;
        gap: 16px;
        padding: 16px 16px 12px 16px;
    }

    border-color: ${(p) => !p.isActive ? 'transparent' : `${COLORS.white}`};
`;

export const Image = styled(LazyLoadImage)<{isActive: boolean}>`
    border-radius: ${BorderRadius.InnerBlockRadius};

    ${(p) => !p.isActive && css`
        filter: grayscale(100%);
    `};
`;

export const TextBlock = styled.div<{isActive: boolean }>`
    max-width: 320px;
    height: fit-content;
    color: ${COLORS.white};
    gap: 6px;
    
    @media (max-width: ${wideBreakpoints.sDesktop}) {
        max-width: 240px;
    }
  
    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: max-content;
    }

    ${(p) => !p.isActive
        ? css`color: ${COLORS.GRAY_S};`
        : css`color: ${COLORS.white};`
    };
`;

export const Subtext = styled.span`
    ${FONTS.M};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.S};
    }
    
    @media (max-width: ${wideBreakpoints.sMobile}) {
        ${FONTS.XS};
    }
`;

export const Title = styled.span`
    ${FONTS.H3};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H4};
    }
`;
